<template>
	<LayoutMain>
		<div class="navsecondary">
			<RouterLink data-ic="O" :to="{ name: 'ProductCreate'}">
				<span>Opret produkt</span>
			</RouterLink>
			<RouterLink data-ic="O" :to="{ name: 'ProductPackageCreate'}">
				<span>Opret produktpakke</span>
			</RouterLink>

			<input type="search" v-model="searchinput" /><i data-ic="Q"></i>
		</div>
		<section>
			<h1>Produkter</h1>

			<ul class="tabs">
				<li>
					<RouterLink :to="{ name: 'Products' }">
						Produktpakker
					</RouterLink>
				</li>
				<li>
					<RouterLink :to="{ name: 'ProductsList' }">
						Produkter
					</RouterLink>
				</li>
			</ul>

			<div>
				<transition name="fade">
					<RouterView v-bind:search="searchinput" />
				</transition>
			</div>
		</section>
	</LayoutMain>
</template>

<script>
	import LayoutMain from "@/components/common/LayoutMain.vue";

	export default {
		name: "Agreements",
		data()
		{
			return {
				searchinput: ""
			}
		},
		components: {
			LayoutMain
		},
	};
</script>